import IntegrationsBaseController from 'cio/controllers/integrations';
import { throttle, scheduleOnce } from '@ember/runloop';
import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import WindowMessengerService from 'cio/services/window-messenger';

export default class IntegrationsPublicController extends IntegrationsBaseController {
  @service windowMessenger!: WindowMessengerService;

  // @ts-ignore queryParams in the array format is not typed
  queryParams = [{ queryQP: 'query' }, { selectedCategoryQP: 'selectedCategory' }, { selectedTypeQP: 'selectedType' }];

  public = true;

  @computed('fetchIntegrations.isRunning')
  get loading() {
    this.handleResize();
    return this.fetchIntegrations.isRunning;
  }

  @action
  searchIntegrations(value: string) {
    super.searchIntegrations(value);

    this.handleResize();
    throttle(this, this.handleFilter, 100, false);
  }

  @action
  chooseCategory(category: string) {
    super.chooseCategory(category);

    this.handleResize();
    this.handleFilter();
  }

  @action
  chooseType(type: string) {
    super.chooseType(type);

    this.handleResize();
    this.handleFilter();
  }

  @action
  handleFilter() {
    this.windowMessenger.send('filter', {
      query: this.query,
      selectedCategory: this.selectedCategory,
      selectedType: this.selectedType,
    });
  }

  @action
  handleResize() {
    throttle(this, this.sendNewSize, 100);
  }

  @action
  sendNewSize() {
    scheduleOnce('afterRender', this.windowMessenger, () => {
      this.windowMessenger.send('resize', {
        height: document.querySelector('.public-integrations-list')?.clientHeight,
      });
    });
  }

  @action
  onNewIntegrationClick() {
    super.onNewIntegrationClick();

    this.windowMessenger.send('modal-open', {});
  }

  @action
  onNewIntegrationClose() {
    super.onNewIntegrationClose();

    this.windowMessenger.send('modal-close', {});
  }
}
